/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { INodeProps, Node, Module, Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ISingleOrderTemplateViewProps } from './components';
import { IOrderTemplateListViewProps } from './krannich-c-order-template-list';
import {
    IKrannichCOrderTemplateListProps,
    IKrannichCOrderTemplateListResources
} from './krannich-c-order-template-list.props.autogenerated';

export const OrderTemplateListView: React.FC<IOrderTemplateListViewProps & IKrannichCOrderTemplateListProps<{}>> = props => {
    const {
        OrderTemplateList,
        status,
        statusMessage,
        heading,
        OrderTemplates,
        orderTemplates,
        OrderTemplate,
        createOrderTemplateButton,
        templateHeaderStatusMessage,
        isMobile
    } = props;
    if (isMobile) {
        return (
            <Module {...OrderTemplateList}>
                {heading}
                {status !== 'SUCCESS' && statusMessage}
                <Node className=''>
                    {createOrderTemplateButton}
                    {templateHeaderStatusMessage}
                </Node>
                {OrderTemplates && orderTemplates && orderTemplates.length > 0 && (
                    <Node {...OrderTemplates}>
                        {orderTemplates &&
                            orderTemplates.map(orderTemplate => {
                                return _renderOrderTemplateForMobile(orderTemplate, OrderTemplate);
                            })}
                    </Node>
                )}
            </Module>
        );
    } else {
        return (
            <Module {...OrderTemplateList}>
                {heading}
                {status !== 'SUCCESS' && statusMessage}
                <Node className=''>
                    {createOrderTemplateButton}
                    {templateHeaderStatusMessage}
                </Node>
                {OrderTemplates && orderTemplates && orderTemplates.length > 0 && (
                    <Node {...OrderTemplates}>
                        <li className='order-template-lines-container'>
                            <span className='order-template-name'>{props.resources.orderTemplateName}</span>
                            <span className='order-template-lines-no'>{props.resources.productsInTemplate}</span>
                            <span className='order-template-actions'>{props.resources.actionsHeadingTemplate}</span>
                        </li>
                        {orderTemplates &&
                            orderTemplates.map(orderTemplate => {
                                return _renderOrderTemplate(orderTemplate, OrderTemplate);
                            })}
                    </Node>
                )}
            </Module>
        );
    }
};

const _renderOrderTemplate = (
    orderTemplate: ISingleOrderTemplateViewProps,
    OrderTemplate?: INodeProps,
    resources?: IKrannichCOrderTemplateListResources
): JSX.Element | null => {
    const { key, orderTemplateStatusMessage, removeButton, orderTemplateName } = orderTemplate;

    const [showAlert, setShowAlert] = React.useState<boolean>(false);
    const toggleAlert = () => {
        setShowAlert(!showAlert);
    };
    return (
        <Node key={key} className={OrderTemplate!.className} {...OrderTemplate}>
            {showAlert && (
                <Modal
                    wrapClassName='ms-order-template-mobile-view-modal buybox-description-popup-container'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={true}
                    toggle={toggleAlert}
                >
                    <div className='alert-modal-body-container'>
                        <ModalHeader toggle={toggleAlert}>Delete Template</ModalHeader>
                        <ModalBody>
                            <span>Do you want to delete the selected order Template?</span>
                            <div className='alert-btn-group'>
                                {removeButton}
                                <button className='msc-delete-orderTemplateList-btn btn cancel-btn ' onClick={toggleAlert}>
                                    Cancel
                                </button>
                            </div>
                        </ModalBody>
                    </div>
                </Modal>
            )}
            {orderTemplateName}
            {/* {orderTemplateImage} */}
            {/*addToCartButton*/}
            {/* {removeButton} */}
            <div className='clear-cart'>
                <button onClick={toggleAlert}>x</button>
            </div>
            {orderTemplateStatusMessage}
        </Node>
    );
};

const _renderOrderTemplateForMobile = (
    orderTemplate: ISingleOrderTemplateViewProps,
    OrderTemplate?: INodeProps,
    resources?: IKrannichCOrderTemplateListResources
): JSX.Element | null => {
    const { orderTemplateStatusMessage, removeButton, orderTemplateName } = orderTemplate;
    const [showAlert, setShowAlert] = React.useState<boolean>(false);
    const toggleAlert = () => {
        setShowAlert(!showAlert);
    };
    return (
        <div className='order-template-block'>
            {showAlert && (
                <Modal
                    wrapClassName='ms-order-template-mobile-view-modal buybox-description-popup-container'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={true}
                    toggle={toggleAlert}
                >
                    <div className='alert-modal-body-container'>
                        <ModalHeader toggle={toggleAlert}>Delete Template</ModalHeader>
                        <ModalBody>
                            <span>Do you want to delete the selected order Template?</span>
                            <div className='alert-btn-group'>
                                {removeButton}
                                <button className='msc-delete-orderTemplateList-btn btn cancel-btn ' onClick={toggleAlert}>
                                    Cancel
                                </button>
                            </div>
                        </ModalBody>
                    </div>
                </Modal>
            )}
            <div className='_title-container'>
                {/* <span className='_title'>Template Title: </span> */}
                {orderTemplateName}
            </div>

            <div className='clear-cart'>
                {/* <span>Actions: </span> */}
                <button onClick={toggleAlert}>x</button>
            </div>
            {orderTemplateStatusMessage}
        </div>
    );
};

export default OrderTemplateListView;
